<template>
    <div class="main-contents flex flex-col  gap-2 p-4 bg-[#5D5D98] rounded-[10px] bg-opacity-[0.55] ">
        <!-- <p class="text-[#ff9b05]">Criar Faturação</p> -->
        <div class="w-full flex flex-col  gap-2 p-4 bg-[#4646768c] rounded-[10px] bg-opacity-[0.55] text-white">
            <div class="flex flex-col gap-4  justify-between">
                <!-- <span class="text-[.7em] opacity-50">{{currentDate}}</span> -->
                
                <AppButton class="self-end text-white ml-auto" v-bind:visibility="true" :padding="'0px'"
                left_icon="fa-regular fa-circle-xmark fa-xl" emitType="close" @click="close" @close="close" :width=23 :height=23 />

                <div class="flex gap-2  w-full items-center">
                    <div class="flex gap-2  ">
                        <label for="stockInput" class="pointer">Stock:</label>
                        <input type="checkbox" v-model="faturacao.stock" name="" id="stockInput">
                        <!-- <input type="text" v-model="faturacao.stock" 
                            class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] lg:max-w-24"> -->
                    </div>
                    <div class="flex gap-2  ">
                        <label>Quantidade:</label>
                        <input type="text" v-model="faturacao.quantidade"
                            class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] lg:max-w-40">
                    </div>
                    <!-- <div class="flex gap-2  ">
                        <label>Data:</label> 
                        <input type="text" v-model="currentDate" readonly
                            class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] lg:max-w-24">
                    </div> -->
                    <div class="flex gap-2 items-center  ">
                        <p>Iva:</p>
                        <div style="color: #ff9b05;">
                            {{ faturacao.tpiva?.nome ?? 'N/A'
                            }}<!-- <button class="btn" style="background-color: #ff9b05;" @click="selectTable(this.armazem_name)">atribuir Armazem</button> -->
                        </div>
                        <button class="fa-solid fa-pen-to-square text-2xl" style="color: #ff9b05;"
                            @click="openDialog('tpiva', 'faturacao')"></button>
                    </div>

                    <div class="flex gap-2 items-center">
                        <p>Total Com IVA:</p>
                        <p class="text-[#ff9b05]">{{ 'N/A' }}
                        </p>
                        <button class="fa-solid fa-pen-to-square text-2xl" style="color: #ff9b05;"
                            @click="openDialog('tpmoeda')"></button>
                    </div>

                    <!-- <div class="flex items-center gap-1">
                        <label class="" for="Any">Cliente:</label>
                        <div class="relative group">
                            <div class=" cursor-default  text-[#ff9b05] max-w-xs truncate">
                                {{ getFieldContacto(fatura_contacto).length > 5 ?
                                    getFieldContacto(fatura_contacto).substring(0, 7) + '...' :
                                    getFieldContacto(fatura_contacto) }}
                            </div>
                            <div v-if="getFieldContacto(fatura_contacto) != 'N/A'"
                                class=" absolute left-0 top-full mt-2 hidden w-max max-w-xs bg-[#ff9b05] text-white text-sm rounded p-2 group-hover:block">
                                {{ getFieldContacto(fatura_contacto) }}
                            </div>
                        </div>
                        <button @click="showCrudPopUp = true" class="fa-solid fa-pen-to-square text-2xl"
                            :style="{ color: !active_state.includes(propsData.status) ? '#7B7B99' : '#ff9b05' }"
                            :disabled="!active_state.includes(propsData.status)"></button>
                    </div> -->


                </div>
                <div class="flex gap-2  w-full">
                    <div class="flex gap-2  ">
                        <label>Subtotal:</label>
                        <input type="text" v-model="faturacao.subTotal" readonly
                            class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] lg:max-w-40">
                    </div>

                    <div class="flex gap-2  ">
                        <label>Desconto:</label>
                        <input type="text" v-model="faturacao.desconto"
                            class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] lg:max-w-40">
                    </div>
                    <div class="flex gap-2  ">
                        <label>Total:</label>
                        <!-- <b style="color: #ff9b05;">
                            {{ faturacao.valorTotal ?? 'N/A' }}
                        </b> -->
                        <input type="text" v-model="faturacao.valorTotal"
                            :readonly="onlyReadInputs.includes('valorTotal') ? true : false"
                            class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] lg:max-w-40">
                    </div>

                </div>
            </div>
        </div>


        <!-- ********************************* ITEM DE FATURACAO******************************************** -->


        <div class="w-full flex flex-col  gap-2 p-4 bg-[#4646768c] rounded-[10px] bg-opacity-[0.55] text-white">
            <div class="flex flex-col gap-4 ">
                <!-- <div class="flex gap-2 items-center">
                    <div class="flex gap-2">
                        <label>Equipamento:</label>
                        <input type="text" v-model="itemFaturacao.quantidade"
                            class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] w-96">
                    </div>
                    <button class="fa-solid fa-pen-to-square text-2xl " style="color: #ff9b05;"
                        @click="openDialog('equipamento')"></button>
                </div> -->
                <div class="select-obj flex gap-4">
                    <div class="data_setd flex gap-1 items-center">
                        <div style="">
                            Equipamento:
                        </div>
                        <div style="color: #ff9b05;">
                            {{ itemFaturacao.equipamento?.nome ??
                            'N/A'}}<!-- <button class="btn" style="background-color: #ff9b05;" @click="selectTable(this.armazem_name)">atribuir Armazem</button> -->
                        </div>
                        <div class="pl-5 flex items-center h-full">
                            <!-- <button @click="openDialog('equipamento')"> -->
                            <button class="fa-solid fa-pen-to-square text-2xl g-edit-icon" style="color: #ff9b05;"
                                @click="openDialog('equipamento', 'itemFaturacao')"></button>
                            <!-- </button> -->
                        </div>
                    </div>

                </div>

                <div class="flex gap-2  w-full items-center">
                    <div class="flex gap-2  ">
                        <label>Unitario:</label>
                        <input type="text" v-model="itemFaturacao.valorUnitario"
                            class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] lg:max-w-40">
                    </div>
                    <div class="flex gap-2  ">
                        <label>Quantidade:</label>
                        <input type="text" v-model="itemFaturacao.quantidade" min="1"
                            class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] lg:max-w-40">
                    </div>
                    <div class="flex gap-2  ">
                        <label>Desconto:</label>
                        <input type="text" v-model="itemFaturacao.desconto"
                            class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] lg:max-w-40">
                    </div>
                    <div class="flex gap-2">
                        <label>Total:</label>
                        <input type="text" v-model="calcValorTotal" readonly
                            class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] lg:max-w-40">
                        <!-- <strong style="color: #ff9b05;">
                                {{ faturacao.valorTotal ?? 'N/A' }}
                            </strong> -->
                    </div>
                    <div>
                        <button class="flex content-center" @click="addItems">
                            <span class="fa-solid fa-circle-plus text-[#ff9b05] fa-2xl"
                                style="font-size: 1.2em;"></span>
                        </button>
                        <!-- <button class="fa-solid fa-trash text-red-500 fa-2xl"></button> -->
                    </div>

                </div>
            </div>
        </div>
        <AppTable :visibility="true" :show="true" :table_data="itemList" table_title="Itens da Faturação"
            @row-clicked="null" @close="" @delete_data="null" />
        <div class="flex gap-2 items-center">
            <AppButton class="capitalize" v-bind:visibility="true" :font_size="12" color="#9797EF"
                text="Criar Faturação" emitType="select" @select="null" />
            <!-- <AppButton class="capitalize" v-bind:visibility="true" :font_size="12" color="#9797EF" text="Encomendar"
                emitType="select" @select="null" /> -->
            <!-- <div class="flex gap-2  ">
                <label>Numero:</label>
                <input type="text" v-model="data.data"
                    class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] lg:max-w-40">
            </div> -->

            <!-- <div class="flex items-center ml-auto  gap-2">
                <label class="" for="Any">{{ 'Utilizador ID:' }}</label>
                <input :disabled="true" class="text-black text-[10px] border-1 border-[#ccc] p-1 rounded-[5px] "
                    type="number" :value="active_state.includes(propsData.status) ? loggedID : utilizador_id"
                    :placeholder="key">
            </div> -->
        </div>
        <Dialog v-if="showDialog" :propsData="dialogProps" @close="closeDialog" @returnData="handleReturnData" />
    </div>

    <CrudPopUp v-if="showCrudPopUp" title="Contactos" :crud_data="{
        model: {
            id: 0,
            nome: '',
            email: '',
            telefone: '',
            telemovel: '',
            descricao: '',

        },
        set_id: {
            tipo: 'tpContacto_id',
        },
        type: 'contacto',
        owner: {
            id: propsData.localInstalacao.id,
            name: 'localinstalacao',
        },
        multiTable: true,
    }" @close="showCrudPopUp = false" @set_entity="set_contato" />


</template>


<script>
import { id as loggedID } from '@/extraData'
import axios from 'axios';
import { toast } from 'vue3-toastify';
import AppTable from '@/components/tables/table.vue'
import AppButton from '@/components/updated/button.vue'
// import { toast } from 'vue3-toastify';
import Dialog from '@/components/dialog/dinamicDialog.vue';
import CrudPopUp from '@/components/popUps/crudPopUp.vue'

export default {
    name: 'faturacao',
    components: {
        AppButton,
        AppTable,
        Dialog,
        CrudPopUp
    },
    props: {
        data: {
            type: Object,
            default: {},

        },
        propsData: {
            type: Object,
            default: {},
        },

        faturacaoProps: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            baseURL: process.env.VUE_APP_URL_BASE,
            loggedID: loggedID,

            active_state: ['ativo', 'pedido', 'proposta','orcamento','validacao', 'encomenda', 'armazem','agendamento', 'execucao','relatorio'],

            onlyReadInputs: ['total', 'preco', 'valorTotal', 'stock'], // 'valorUnitario'
            onlyReadInputs2: ['subTotal'],
            currentEntity: null,
            currentType: null,
            currentNegocio: null,


            faturacao: {
                stock: '',
                subTotal: '',
                numero: 0,
                valorTotal: 0,
                quantidade: 0,
                valorTotalComIva: 0,
                desconto: 1,
                // cliente_id: 0,
                // subCliente_id: 0,
                // localInstalacao_id: 0,
                // iva: 0,
                tpiva: {
                    id: 0,
                    nome: null,
                },
                tpmoeda: {
                    id: 0,
                    nome: null,
                }

                // disabadStyle:{
                //     backgroundColor: '
                // }
            },
            itemFaturacao: {
                faturaCliente_id: 0,
                // equipamento_id: 0,
                equipamento: null,
                subTotal: 0,
                quantidade: 1,
                desconto: 0,
                valorUnitario: 0,
                valorTotal: 0,
                valorTotalComIva: 0,

                tpiva: {
                    id: 0,
                    nome: '',
                },

            },
            currentDate: this.getCurrentDate(),
            showDialog: false,
            currentType: null,
            dialogProps: {
                entity: ['equipamento', 'tpiva', 'tpmoeda', 'tpprioridade', 'tpprazo'],
                buttons: ['test'],
                sideBar: true,
                multi: false,
                queryParams: { 'equipamento': 'custom=1' },
            },
            itemList: [
                { id: 1, equipamento: 'Equipamento 1', 'valor unitario': 100, quantidade: 1, desconto: 0, total: 100 },
                // { id: 2, equipamento: 'Equipamento 2', unitario: 200, qtd: 1, desconto: 0, total: 200 },
                // { id: 3, equipamento: 'Equipamento 3', unitario: 300, qtd: 1, desconto: 0, total: 300 },
                // { id: 4, equipamento: 'Equipamento 4', unitario: 400, qtd: 1, desconto: 0, total: 400 },
                // { id: 5, equipamento: 'Equipamento 5', unitario: 500, qtd: 1, desconto: 0, total: 500 },
            ],

            showCrudPopUp: false,

            fatura_contacto: { id: 0, nome: 'N/A', email: 'N/A', telefone: 'N/A', telemovel: 'N/A', descricao: 'N/A' },

            utilizador_id: 0,
        }
    },
    methods: {
        getCurrentDate() {
            const today = new Date();
            const day = String(today.getDate()).padStart(2, '0');
            const month = String(today.getMonth() + 1).padStart(2, '0');
            const year = today.getFullYear();
            return `${day}/${month}/${year}`;
        },


        close() {
            this.$emit('close');
        },

        openDialog(objecto, entity = null) {
            this.currentEntity = entity;
            this.dialogProps.entity[0] = objecto;
            this.showDialog = true;
            this.currentType = objecto;
        },
        closeDialog() {
            this.showDialog = false;
        },
        handleReturnData(data) {
            // console.log('Returned data:', data);

            if (this.currentEntity == 'faturacao') {
                this.faturacao[[this.currentType]] = data[[this.currentType]];
            } else {

                this.itemFaturacao[[this.currentType]] = data[[this.currentType]];
            }

        },

        addItems() {

            if (!this.itemFaturacao.equipamento) {
                toast("campo obrigatório vazio!", {
                    "theme": "auto",
                    "type": "warning",
                    "position": "top-center",
                    "autoClose": 1000,
                });
                return;
            }



            else if (this.itemList.some(item => item.equipamento === this.itemFaturacao.equipamento.nome)

            ) {
                toast("Item já adicionado!", {
                    "theme": "auto",
                    "type": "warning",
                    "position": "top-center",
                    "autoClose": 1000,
                });
                return;
            }

            this.itemList.push({
                id: this.itemList.length + 1,
                equipamento: this.itemFaturacao.equipamento.nome,
                'valor unitario': this.itemFaturacao.valorUnitario,
                quantidade: this.itemFaturacao.quantidade,
                desconto: this.itemFaturacao.desconto,
                total: this.itemFaturacao.valorTotal,
            });
        },

        async registerFaturacao() {
            const data= {
                faturaCliente_id: this.faturacaoProps.faturaCliente_id,
                stock: this.faturacao.stock,
                subTotal: this.faturacao.subTotal,
                numero: this.faturacao.numero,
                valorTotal: this.faturacao.valorTotal,
                quantidade: this.faturacao.quantidade,
                valorTotalComIva: this.faturacao.valorTotalComIva,
                desconto: this.faturacao.desconto,
                tpiva_id: this.faturacao.tpiva.id,
                tpmoeda_id: this.faturacao.tpmoeda.id,
                utilizador_id: this.utilizador_id,
                contactoCliente_id: this.fatura_contacto.id,
            }

        },

        async registrarItemFaturacao() {
            try {
                const response = await axios.post(`${this.baseURL}/api/v1/faturacao`, this.itemFaturacao);

                return response.status;

            } catch (error) {
                console.error(error);
                toast("Erro ao registar item de faturação!", {
                    "theme": "auto",
                    "type": "error",
                    "position": "top-center",
                    "autoClose": 1000,
                });
            }
        },


        async submitForm() {

        },

        async getContacto(contacto_id) {
            if (contacto_id == 0) { 
                return
            }
            const res = await this.select_all(`${this.baseURL}/api/v1/contacto/${contacto_id}/`);
            if (res) {
                console.log("Contacto:", res)
                // this.infoCard_data['Contacto'] = this.getFieldContacto(res);
                this.fatura_contacto = JSON.parse(JSON.stringify(res));
            }
        },

        set_contato(entity) {
            console.log('fatura contato entity:', entity);
            this.showCrudPopUp = false;
            this.fatura_contacto = JSON.parse(JSON.stringify(entity));
        },

        getFieldContacto(contacto) {
            const fields = ['nome', 'email', 'telefone', 'telemovel', 'descricao'];
            for (const field of fields) {
                if (contacto[field] && contacto[field] !== 'N/A') {
                    return contacto[field];
                }
            }
            return 'N/A';
        },

        async select_all(url) {
            try {
                const res = await axios.get(url);
                return res.data.data;

            } catch (error) {
                console.error('Error getting data:', error);
            }

        },



    },
    computed: {
        calcValorTotal() {
            // console.table(this.itemFaturacao);
            // this.faturacao.subTotal = this.items.reduce((acc, item) => acc + item.total, 0);
            this.itemFaturacao.valorUnitario = parseFloat(this.itemFaturacao.valorUnitario) || 0;
            this.itemFaturacao.quantidade = parseInt(this.itemFaturacao.quantidade) || 1;
            this.itemFaturacao.desconto = parseFloat(this.itemFaturacao.desconto) || 0;
            // let total = preco * qtd - desconto;
            this.itemFaturacao.valorTotal = this.itemFaturacao.valorUnitario * this.itemFaturacao.quantidade - this.itemFaturacao.desconto;
            return this.itemFaturacao.valorTotal;
        },
    },
    created() {
        console.log('Faturacao created');
        console.table(this.faturacao);
    },

    watch: {
        propsData: {
            handler: function (newVal) {
                console.log('Props data changed: ', newVal);
                this.fatura_contacto = { id: 0, nome: 'N/A', email: 'N/A', telefone: 'N/A', telemovel: 'N/A', descricao: 'N/A' },

                this.utilizador_id= 0,

                this.currentNegocio = newVal;
            },
            deep: true,
        },

        faturacaoProps: {
            handler: function (newVal) {
                const isEmptyObject = obj => Object.keys(obj).length === 0 && obj.constructor === Object;

                console.log('Faturacao changed: ', newVal);
                if(!isEmptyObject(newVal.faturaCliente)){
                    this.utilizador_id = newVal.faturaCliente.utilizador_id;
                    this.getContacto(newVal.faturaCliente.contacto_id);
                }
                
            },
            deep: true,
        },
    }
}


</script>





<style scoped>
.button-container {
    display: flex;
    flex-wrap: wrap;

    gap: 10px;
    /* Adjust the gap as needed */
}

.main-contents {
    /* background-color: blue;  */
    max-width: 70em;
}


input:disabled {
    background-color: rgba(204, 204, 204, 1);
}

/* .button-wrapper {
    flex: 1 1 calc(50% - 4.5px);
    max-width: calc(50% - 4.5px);
} */
</style>
